import React from "react";
import Layout from "../../layouts/landing";
import Hero from "../../components/templates/landing/InstantCash/Hero";
import TrustBar from "../../components/templates/landing/InstantCash/TrustBar";
import UseCases from "../../components/templates/landing/InstantCash/UseCases";
import AboutPatria from "../../components/templates/landing/InstantCash/AboutPatria";
import HowItWorks from "../../components/templates/landing/InstantCash/HowItWorks";
import PageFooter from "../../components/templates/landing/InstantCash/PageFooter";
import Disclaimer from "../../components/templates/landing/InstantCash/Disclaimer";
import { tribesConfig } from "../../app.config";
import { Theme } from "./styles-instant-cash";

import usecaseCar from "../../assets/landing/usecase-car.jpg";
import usecaseMedical from "../../assets/landing/usecase-medical.jpg";
import usecaseHome from "../../assets/landing/usecase-home.jpg";
import breathing from "../../assets/landing/patria-breathing.png";

const COMPANY = "Patria Lending";
/* The reference links "click here" at the tribe's own about page rather than a
 * route in this app, so it is built from the tenant's configured website.
 *
 * Read from the env var rather than tribesConfig.website: that one is
 * String(process.env...), and String(undefined) is the string "undefined", so an
 * unset var produced the truthy "https://undefined/about" and Disclaimer
 * rendered the sentence with a dead link instead of dropping it. process.env is
 * undefined or "" when absent, which is falsy. */
const tribeWebsite = process.env.REACT_APP_TRIBE_WEBSITE?.trim();
const tribeInfoUrl = tribeWebsite
  ? `https://${tribeWebsite.replace(/^https?:\/\//, "")}/about`
  : undefined;

const useCases = [
  {
    pill: "Car repair",
    title: "Get back on the road, fast.",
    text: "Cover a new alternator, tires, or a tow — before you miss another shift.",
    image: usecaseCar,
    alt: "A mechanic finishing up a repair in a driveway",
  },
  {
    pill: "Medical bills",
    title: "Handle a bill you didn't plan for.",
    text: "From an ER co-pay to a prescription refill, get funds before the due date.",
    image: usecaseMedical,
    alt: "A woman at her kitchen table reviewing a medical bill",
  },
  {
    pill: "Home & appliances",
    title: "Fix the fridge. Fix the leak.",
    text: "Keep your home running when the washer, HVAC, or water heater gives out.",
    image: usecaseHome,
    alt: "A father and daughter at an open refrigerator",
  },
];

const trustSignals = [
  "Bank-level security",
  "40M+ Americans served",
  `Owned by ${tribesConfig.tribalLands} Tribe`,
  "No hidden fees",
];

const metrics = [
  { value: "$2,000", label: "Max loan" },
  { value: "60s", label: "Approval" },
  { value: "0", label: "Hidden fees" },
];

const InstantCash = () => {
  return (
    <Theme>
      <Layout showApplyCta footer={<PageFooter companyName={COMPANY} />}>
        <Hero />
        <TrustBar signals={trustSignals} />
        <UseCases useCases={useCases} />
        <AboutPatria
          image={breathing}
          alt="A Patria customer feeling relief"
          badge="Approved in 42 seconds"
          metrics={metrics}
        />
        <HowItWorks />
        <Disclaimer
          companyName={COMPANY}
          tribe={`${tribesConfig.tribalLands} Tribe`}
          moreInfoUrl={tribeInfoUrl}
        />
      </Layout>
    </Theme>
  );
};

export default InstantCash;
